export default {
    setPasswordRules(state, payload) {
        state.passwordRules = payload;
    },

    setHasPolicy(state, payload) {
        state.hasPolicy = payload;
    },

    setHasSamlProvider(state, payload) {
        state.hasSamlProvider = payload;
    },

    setRedemptionToken(state, payload) {
        state.redemptionToken = payload;
    },

    updateLoading(state, payload) {
        state.loading = Object.assign({}, state.loading, payload);
    },

    updateDialogVisible(state, payload) {
        state.dialogVisible = Object.assign({}, state.loading, payload);
    },

    updatePasswordIsValid(state, payload) {
        state.passwordIsValid = payload;
    },

    updateSettingsForm(state, payload) {
        state.settingsForm = payload;
    },

    updateMfaSettingsForm(state, payload) {
        state.mfaSettingsForm = Object.assign({}, state.mfaSettingsForm, payload);
    },

    updateAllAdminUsers(state, payload) {
        state.allAdminUsers = payload;
    },

    updateValid(state, payload) {
        state.valid = payload;
    },

    updatePasswordForm(state, payload) {
        state.passwordForm = Object.assign({}, state.passwordForm, payload);
    },

    setAllowNativeLogin(state, payload) {
        state.allowNativeLogin = typeof payload !== 'undefined' && (payload === 1 || payload === '1' || payload === true);
    },

    updateOrgSecurityQuestionSettingsForm(state, payload) {
        state.orgSecurityQuestionSettingsForm = Object.assign({}, state.orgSecurityQuestionSettingsForm, payload);
    },

    setSecurityQuestions(state, payload) {
        state.passwordForm.securityQuestions = payload;
    },

    setAnswerSecurityQuestionsForm(state, payload) {
        state.answerSecurityQuestionsForm.securityQuestions = payload;
    },

    setOrgSecurityQuestionsForm(state, payload) {
        state.orgSecurityQuestionsForm.defaultOrgSecurityQuestions = payload.defaultOrgSecurityQuestions;
        state.orgSecurityQuestionsForm.customOrgSecurityQuestions = payload.customOrgSecurityQuestions;
    },

    setRecaptchaSiteKey(state, payload) {
        state.recaptchaSiteKey = payload;
    },

    setIsRecaptchaValid(state, payload) {
        state.isRecaptchaValid = payload;
    },
}